<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="upsert()">
    <v-container fluid>
      <v-layout class="ma-0">
        <v-flex
          xs12
          sm8
          offset-sm2
          md6
          offset-md3
          xl4
          offset-xl4
          class="background-white box-shadow"
        >
          <v-text-field
            v-model="edited.type"
            :rules="rules.type"
            label="Name"
            :disabled="upserting"
            autofocus
          />
          <v-text-field
            v-model="edited.description"
            :rules="rules.description"
            label="Description"
            :disabled="upserting"
          />
          <v-layout justify-end>
            <v-btn
              type="submit"
              :disabled="!valid || upserting"
              :loading="upserting"
              color="primary"
            >
              Save
            </v-btn>
            <v-btn type="button" @click.stop="$router.go(-1)">
              Back
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TypeUpsert",
  data: () => ({
    valid: false,
    edited: {},
    rules: {
      type: [v => !!v || "This field is required"],
      description: [v => !!v || "This field is required"]
    }
  }),
  computed: {
    ...mapGetters({
      list: "types/list",
      removing: "types/removing",
      toRemove: "types/toRemove",
      toUpsert: "types/toUpsert",
      upserting: "types/upserting",
      getTypeById: "types/getById"
    })
  },
  created() {
    if (this.toUpsert.id != this.$route.params.typeId) {
      const type = this.getTypeById(this.$route.params.typeId);
      if (type.id == this.$route.params.typeId) {
        this.setToUpsert(type);
      } else {
        this.$router.replace({ name: "Types" });
      }
    }

    this.hydrate();

    const title =
      this.toUpsert.id === -1
        ? `Create Category`
        : `Edit ${this.toUpsert.type}`;
    this.setPageTitle(title);

    this.edited = {
      ...this.toUpsert,
      type: this.getTypeById(this.$route.params.typeId).type
    };
  },
  methods: {
    ...mapActions({
      hydrate: "types/hydrate",
      create: "types/create",
      update: "types/update",
      setPageTitle: "ui/setPageTitle",
      setToUpsert: "types/setToUpsert"
    }),
    upsert() {
      if (this.$refs.form.validate()) {
        if (this.toUpsert.id === -1) {
          this.create(this.edited);
        } else {
          this.update(this.edited);
        }
      }
    }
  }
};
</script>
